<!-- Do not change this file. -->
<template>
  <div class="container-sm">
    <div class="row justify-content-center">
      <div class="col col-sm-8 col-md-6">
        <CustomAlert type="light" class="rounded-5">
          <div class="text-center pt-3">
            <div class="spinner-border text-primary mb-2"></div>
            <div class="text-primary fs-4 ms-3 text-dark">
              {{ loadingMessage }}
            </div>
            <div class="text-secondary fs-5 my-3">
              {{ errorMessage }}
            </div>
          </div>
        </CustomAlert>
      </div>
    </div>
  </div>
</template>

<script>
import CustomAlert from "@/components/ui/CustomAlert.vue";

export default {
  name: "LoadingComponent",
  components: {
    CustomAlert
  },
  data() {
    return {
      loadingMessage: "Loading...",
      errorMessage: "If the loading takes too long, please refresh the page."
    };
  }
};
</script>
